import { ReactElement } from "react";
import { useSelector } from "react-redux";
import { RootState } from "../../../store";
import { useRestoreSession } from "../../../hooks/useRestoreSession";
import RoutePopup from "../../RoutePopup";
import { useNavigate } from "react-router-dom";

interface ProtectedRouteProps {
    children: ReactElement;
}

function ProtectedRoute({ children }: ProtectedRouteProps): ReactElement {
    const { user } = useSelector((state: RootState) => state.auth);
    const { isLoading } = useRestoreSession();
    const navigate = useNavigate();

    if (isLoading) return <></>;

    if (!user) {
        return (
            <RoutePopup
                onClose={() => {
                    navigate("/");  
                }}
            />
        );
    }

    return children;
}

export default ProtectedRoute;
